export default {
    targetSetGrade: {
        defaults: {
            rootProperty: 'grades',
            endpoint: 'targetSetV.php' // scope: target_set_id=14
        },
        read: {
            params: {
                action: 'get',
                property: 'grades'
            }
        },
        create: {
            params: {
                action: 'create',
                property: 'grades'
            }
        },
        update: {
            params: {
                action: 'update',
                property: 'grades'
            }
        },
        destroy: {
            params: {
                action: 'delete',
                property: 'grades'
            }
        }
    }
}